/**
 * Validates an URL
 * @category Validators
 * @param {string} value - The URL
 * @returns {(string|false)} Returns `"Invalid url format"` when value is invalid and `false` when it's valid
 */
export function validateUrl(value: string) {
  const pattern = new RegExp(
    '^(https?://)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(:\\d+)?(/[-a-z\\d%_.~+]*)*' + // port and path
      "(\\?[;#:,&a-z\\-\\d%_.'~+=!-{}/]*)?" + // query string
      '(\\#[a-z\\d-_]*=&:,%)?$',
    'i',
  ); // fragment locater

  if (!value || !pattern.test(value)) {
    return 'Invalid url format';
  }

  return false;
}
